import { CalendarRange, RotateCcw } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { hasRange, rangeInvalid, type DateRange } from '@/components/medic/patientCardData';

interface Props {
    value: DateRange;
    onChange: (next: DateRange) => void;
}

export function DateRangeFilter({ value, onChange }: Props) {
    const invalid = rangeInvalid(value);
    return (
        <div className="flex flex-wrap items-center gap-2 rounded-lg border bg-card/60 px-3 py-2">
            <div className="flex items-center gap-1.5 text-[11px] font-medium text-muted-foreground">
                <CalendarRange className="h-3.5 w-3.5" />
                Период
            </div>
            <label className="flex items-center gap-1.5 text-[11px] text-muted-foreground">
                с
                <input
                    type="date"
                    value={value.from}
                    onChange={(event) => onChange({ ...value, from: event.target.value })}
                    className="h-7 rounded-md border bg-background px-2 text-xs text-foreground"
                />
            </label>
            <label className="flex items-center gap-1.5 text-[11px] text-muted-foreground">
                по
                <input
                    type="date"
                    value={value.to}
                    onChange={(event) => onChange({ ...value, to: event.target.value })}
                    className="h-7 rounded-md border bg-background px-2 text-xs text-foreground"
                />
            </label>
            <Button
                size="sm"
                variant="ghost"
                className="h-7 px-2 text-[11px]"
                disabled={!hasRange(value)}
                onClick={() => onChange({ from: '', to: '' })}
            >
                <RotateCcw className="mr-1 h-3 w-3" />
                Сбросить
            </Button>
            {invalid && (
                <span className="text-[11px] font-medium text-destructive">
                    Дата «с» позже даты «по» — данные не показаны
                </span>
            )}
        </div>
    );
}
